<template>
  <div>

    <!-- <div v-for="(account, index) in accounts" :key="index">{{ account }}</div>
    <button class="btn btn-primary" @click="login">LOGIN</button> -->
    <!-- <button class="btn btn-secondary" @click="logout">LOGOUT</button> -->
  </div>
</template>
<script>
import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import axios from "axios";
export default {
  name: "OAuth",
  props: {
    redirectUrl: {
      type: String,
      required: false,
      default: '/'
    }
  },
  data() {
    return {
      msal: null,
      accounts: null,
      account: null,
    };
  },
  methods: {
    async login() {
      const msalConfig = {
        auth: {
          clientId: process.env.VUE_APP_OFFICE_365_SSO_APP_ID,
          authority: "https://login.microsoftonline.com/common",
          redirectUri: `${process.env.VUE_APP_URL}/login`,
        },
        cache: {
          cacheLocation: "localStorage",
        },
      };

      const msalInstance = new PublicClientApplication(msalConfig);
      const oauthUrl = msalInstance.getLoginPopupUrl();  // Get the correct login URL
    const oauthWindow = window.open(oauthUrl, 'MicrosoftOAuth', 'width=600,height=700');

    // Listen for the message from the popup
    window.addEventListener('message', (event) => {
      if (event.origin !== window.location.origin) {
        return; // Only accept messages from your own origin
      }

      const authCode = event.data.authCode;
      if (authCode) {
        // Handle the auth code, e.g., send it to your backend to exchange for tokens
        // console.log('Auth code received:', authCode);
        oauthWindow.close();  // Close the popup
      }
    });
  
    },
    async logout() {
      this.msal.logoutPopup();
    },
    //Gets a Microsoft token to read a user's profile 
    //and load permissions to authenticate user's account
    async checkToken() {
      const tokenRequest = {
        scopes: ["user.read"],
        account: this.account,
      };
      // MSAL only checks the cached ACCESS token's expiry and can return an expired cached ID
      // token, which the server rejects. Ask for fresh tokens unless the ID token has at least
      // ID_TOKEN_MIN_REMAINING_MS left (signup flows use it again after the user fills in a form).
      const ID_TOKEN_MIN_REMAINING_MS = 30 * 60 * 1000;
      const idTokenIsFresh = (res) => (res?.idTokenClaims?.exp ?? 0) * 1000 - Date.now() > ID_TOKEN_MIN_REMAINING_MS;
      const token = await this.msal
        .acquireTokenSilent(tokenRequest, this.account)
        .then((res) => (idTokenIsFresh(res) ? res : this.msal.acquireTokenSilent({ ...tokenRequest, forceRefresh: true })))
        .then(async (res) => {
          try {
          // The ID token (issued to our app) is what the server verifies; the access token
          // lets it confirm the same user with Graph.
          const authToken = res?.accessToken;
          if (authToken) {
            return { accessToken: authToken, idToken: res?.idToken };
          } else {
            return false;
          }
          } catch (e) {
            console.error(e);
            return false;
          }
          
        })
        .catch(async (e) => {
          console.error(e);
          // Silent renewal failed (e.g. the refresh token expired or third-party cookies are
          // blocked): ask the user to sign in interactively instead of failing every retry.
          try {
            const res = await this.msal.acquireTokenPopup({ ...tokenRequest });
            if (res?.accessToken) {
              return { accessToken: res.accessToken, idToken: res?.idToken };
            }
          } catch (popupError) {
            console.error(popupError);
          }
          // Forget the cached account so the next attempt starts a fresh sign-in.
          try {
            await this.msal.clearCache();
          } catch (clearError) {
            console.error(clearError);
          }
          this.$emit('error', e)
          return false;
          //   const tokenPopup = await this.msal
          //     .acquireTokenPopup({
          //       scopes: ["user.read"],
          //       account: this.msal.getActiveAccount(),
          //     })
          //     .then(async (res) => {
          //       // console.log(res);
          //       const token = res?.accessToken;
          //       if (token) {
          //         return token;
          //       } else {
          //         return false;
          //       }
          //     })
          //     .catch((e) => {
          //       console.log(e);
          //     });
        });

      if (token) {
        this.$emit("microsoftOAuth", token.accessToken, token.idToken);
      }
    },
  },
  async mounted() {
    // console.log('Oauth Component Mounted');
    this.$emit('componentMounted');

    const msalConfig = {
      auth: {
        clientId: process.env.VUE_APP_OFFICE_365_SSO_APP_ID,
        authority: "https://login.microsoftonline.com/common",
        redirectUri: `${process.env.VUE_APP_URL}/MicrosoftLoginRedirect`,
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation: "localStorage",
      },
      redirectUri: `${process.env.VUE_APP_URL}/`,
      
      system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
              return;
            }
            switch (level) {
              case LogLevel.Error:
                console.error(message);
                return;
              case LogLevel.Info:
                console.info(message);
                return;
              case LogLevel.Verbose:
                console.debug(message);
                return;
              case LogLevel.Warning:
                console.warn(message);
                return;
            }
          },
        },
      },
    };
    const tokenRequest = {
      scopes: ["openid", "profile"],
    };

    const msalInstance = new PublicClientApplication(msalConfig);
    await msalInstance.initialize()
    this.msal = msalInstance;
    const accounts = this.msal.getAllAccounts();

    if (accounts?.length > 0) {
      this.account = accounts[0];
      this.msal.setActiveAccount(accounts[0]);
      this.$emit("microsoftLogin", accounts[0]);
      this.checkToken();
    } else {
      await this.msal
        .loginPopup(tokenRequest)
        .then((response) => {
          this.msal.setActiveAccount(response.account);
          this.$emit("microsoftLogin", response.account);
          this.checkToken();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  },
};
</script>
